/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateNumericEvaluationParameterDtoEvaluationType } from './CreateNumericEvaluationParameterDtoEvaluationType';
import {
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON,
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoEvaluationTypeToJSON,
} from './CreateNumericEvaluationParameterDtoEvaluationType';
import type { GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter } from './GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter';
import {
    GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterFromJSON,
    GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterFromJSONTyped,
    GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterToJSON,
} from './GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter';
import type { CreateNumericEvaluationParameterDtoLimitType } from './CreateNumericEvaluationParameterDtoLimitType';
import {
    CreateNumericEvaluationParameterDtoLimitTypeFromJSON,
    CreateNumericEvaluationParameterDtoLimitTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoLimitTypeToJSON,
} from './CreateNumericEvaluationParameterDtoLimitType';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetNumericEvaluationParameterTemplateDto
 */
export interface GetNumericEvaluationParameterTemplateDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    taskType: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    quantityId: string;
    /**
     * 
     * @type {string}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    definitionId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    geometryId?: number | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoEvaluationType}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    evaluationType?: CreateNumericEvaluationParameterDtoEvaluationType | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoLimitType}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    limitType?: CreateNumericEvaluationParameterDtoLimitType | null;
    /**
     * 
     * @type {GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    previousEvaluationParameter?: GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameter | null;
    /**
     * 
     * @type {string}
     * @memberof GetNumericEvaluationParameterTemplateDto
     */
    $type?: GetNumericEvaluationParameterTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const GetNumericEvaluationParameterTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetNumericEvaluationParameterTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetNumericEvaluationParameterTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetNumericEvaluationParameterTemplateDtoTypeEnum = typeof GetNumericEvaluationParameterTemplateDtoTypeEnum[keyof typeof GetNumericEvaluationParameterTemplateDtoTypeEnum];



/**
 * Check if a given object implements the GetNumericEvaluationParameterTemplateDto interface.
 */
export function instanceOfGetNumericEvaluationParameterTemplateDto(value?: unknown): value is GetNumericEvaluationParameterTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetNumericEvaluationParameterTemplateDtoTypeEnum)[0];
}

export function GetNumericEvaluationParameterTemplateDtoFromJSON(json: any): GetNumericEvaluationParameterTemplateDto {
    return GetNumericEvaluationParameterTemplateDtoFromJSONTyped(json, false);
}

export function GetNumericEvaluationParameterTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNumericEvaluationParameterTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskType': TaskTypeDescriptionFromJSON(json['taskType']),
        'quantityId': json['quantityId'],
        'definitionId': json['definitionId'] == null ? undefined : json['definitionId'],
        'geometryId': json['geometryId'] == null ? undefined : json['geometryId'],
        'evaluationType': json['evaluationType'] == null ? undefined : CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON(json['evaluationType']),
        'limitType': json['limitType'] == null ? undefined : CreateNumericEvaluationParameterDtoLimitTypeFromJSON(json['limitType']),
        'previousEvaluationParameter': json['previousEvaluationParameter'] == null ? undefined : GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterFromJSON(json['previousEvaluationParameter']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GetNumericEvaluationParameterTemplateDtoToJSON(value?: GetNumericEvaluationParameterTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'quantityId': value['quantityId'],
        'definitionId': value['definitionId'],
        'geometryId': value['geometryId'],
        'evaluationType': CreateNumericEvaluationParameterDtoEvaluationTypeToJSON(value['evaluationType']),
        'limitType': CreateNumericEvaluationParameterDtoLimitTypeToJSON(value['limitType']),
        'previousEvaluationParameter': GetNumericEvaluationParameterTemplateDtoPreviousEvaluationParameterToJSON(value['previousEvaluationParameter']),
        '$type': value['$type'],
    });
}

